// extracted by mini-css-extract-plugin
export default {"container":"modal_container__qjnAZ","genericModal":"modal_genericModal__obaLs","wideModal":"modal_wideModal__oOkcb"};